import React, { use, useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import metaDataServices from './MetaDataServices';
import Pagination from 'components/Common/newPagination';
import AssociatedTrackRelease from './Tracks/AssociatedRelease';

export default function ContractAssetLink(param: any) {

    console.log("param")
    console.log(param)

    let [searchFor, setSearchFor] = useState("");
    let [expandList, setExpanList] = useState<any[]>([]);
    let [activeTab, setactiveTab] = useState("contractTracks");
    let [ContractAssetLinkedRow, setContractAssetLinkedRow] = useState(0);
    let [ContractAssetLinked, setContractAssetLinked] = useState<any>([]);
    let [AssociatedReleaseOpen, setAssociatedReleaseOpen] = useState(false);
    let [AssociatedReleaseSelected, setAssociatedReleaseSelected] = useState<any>([]);

    const [ReleaseTracksPayload, setReleaseTracksPayload] = useState({ pageNumber: 1, pageSize: 10 })
    const [ReleaseSongsPayload, setReleaseSongsPayload] = useState({ pageNumber: 1, pageSize: 10 })
    var payload = { contractRefNum: param?.contractDetails?.contractRefNum, search: "", trackType: 'link', pageNumber: 1, pageSize: 10 }

    useEffect(() => {

        if (param?.type == "Tracks") {
            apiCall("contractTracks")
        }

        if (param?.type == "Songs") {
            apiCall("contractSongs")
        }

        if (param?.type == "Releases") {
            apiCall("contractReleases")
        }

    }, []);

    const closeDrawer = () => { param.onChangContractAssetLink(); }

    const apiCall = (tabName: any) => {

        activeTab = tabName
        setactiveTab(activeTab);

        if (activeTab == "contractTracks") {
            metaDataServices.contractLinkTrack(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "unlinkedTracks") {
            payload.trackType = "notLink"
            metaDataServices.contractLinkTrack(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "linkedTracks") {
            payload.trackType = "otherContract"
            metaDataServices.contractTrackotherContract(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "releaseTracks") {
            payload.trackType = "release"
            metaDataServices.contractTrackReleaseContract(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRowsRelease ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }


        if (activeTab == "contractSongs") {
            metaDataServices.contractLinkSong(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "unlinkedSongs") {
            payload.trackType = "notLink"
            metaDataServices.contractNonLinkSong(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "linkedSongs") {
            payload.trackType = "otherContract"
            metaDataServices.contractSongotherContract(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRows ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

        if (activeTab == "releaseSongs") {
            payload.trackType = "release"
            metaDataServices.contractSongReleaseContract(payload).then((respond: any) => {
                ContractAssetLinked = respond
                setContractAssetLinked(ContractAssetLinked)
                ContractAssetLinkedRow = respond[0]?.totalRowsRelease ?? 0;
                setContractAssetLinkedRow(ContractAssetLinkedRow)
            })
        }

    }

    const paginationContacts = (e: any) => {
        payload.pageNumber = e.pageNumber
        payload.pageSize = e.pageSize
        apiCall(activeTab)
    }

    const expandOption = (e: any) => {
        setExpanList((prevList) => {
            const index = prevList.findIndex((valListing) => valListing.releaseCode === e);

            if (index !== -1) {
                return prevList.map((item, i) => i === index ? { ...item, expand: !item.expand } : item);
            } else {
                return [...prevList, { releaseCode: e, expand: true }];
            }
        });
    };

    const expandOptionShow = (e: any) => {
        const index = expandList.findIndex((valListing: any) => valListing.releaseCode == e)

        console.log(index)
        var return_val = false;

        if (index != -1) {
            return_val = expandList[index]?.expand
        }
        console.log(return_val)

        return return_val;
    }

    const paginationReleaseSong = (e: any) => {
        ReleaseSongsPayload.pageNumber = e.pageNumber
        ReleaseSongsPayload.pageSize = e.pageSize
        setReleaseSongsPayload(existingValues => ({ ...ReleaseSongsPayload, pageNumber: e.pageNumber, pageSize: e.pageSize }))
    }

    const paginationReleaseTracks = (e: any) => {
        ReleaseTracksPayload.pageNumber = e.pageNumber
        ReleaseTracksPayload.pageSize = e.pageSize
        setReleaseTracksPayload(existingValues => ({ ...ReleaseTracksPayload, pageNumber: e.pageNumber, pageSize: e.pageSize }))
    }

    const operationType = (operationName: any, value: any) => {

        console.log(value)
        console.log(operationName)
        console.log(param?.contractDetails?.contractRefNum)
        if (operationName == "Un-link" && param?.type == "Tracks") {
            metaDataServices.unLinkContractTrack(value, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }

        if (operationName == "link" && param?.type == "Tracks") {
            metaDataServices.linkTrackToContract(value, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }

        if (operationName == "linkRelease" && param?.type == "Tracks") {
            metaDataServices.linkTrackToContract(value?.tracks, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }


        if (operationName == "Un-link" && param?.type == "Songs") {
            metaDataServices.unLinkContractSong(value, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }

        if (operationName == "link" && param?.type == "Songs") {
            metaDataServices.linkSongToContract(value, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }

        if (operationName == "linkRelease" && param?.type == "Songs") {
            metaDataServices.linkSongToContract(value?.tracks, param?.contractDetails?.contractRefNum).then((respond: any) => {
                apiCall(activeTab)
            })
        }
    }

    const onChangAssociatedRelease = (e: any) => {
        AssociatedReleaseOpen = false;
        setAssociatedReleaseOpen(AssociatedReleaseOpen)
    }

    const searchData = () => {
        payload.search = searchFor;
        apiCall(activeTab)
    }

    return (<>

        <Drawer open={param.ContractAssetLinkOpen} onClose={closeDrawer} direction='right' className='react-drawer allowHscroll allowVscroll' size={800}>

            <div className="box ws-9 pull-right landing">
                <div className="ws-12 box-header-main">
                    <h1 className="mlxl pull-left text-center">Link {param?.type}</h1>
                </div>

                <div className="ws-12  pts">
                    <div className='ws-12 pm'>

                        <fieldset className="scheduler-border p0 m0">
                            <legend className="scheduler-border">
                                <h2 style={{ color: "#47529d" }} >  contract Info </h2>
                            </legend>

                            <div className="ws-12">

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr">  Contract Code : </label>
                                        <div className="label-entries ws-8">  {param?.contractDetails?.contractRefNum}  </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr">  Contract Title : </label>
                                        <div className="label-entries ws-8">  {param?.contractDetails?.contractTitle}  </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr"> Contact :  </label>
                                        <div className="label-entries ws-8"> {param?.contractDetails?.contractAccount} ({param?.contractDetails?.contractAccountCode})  </div>
                                    </div>
                                </div>
                            </div>

                        </fieldset>

                    </div>


                    <div className='ws-12 ps'>
                        <ul className="nav nav-tabs nav-justified ws-12 m0 p0 mtl mbl">
                            {param?.type == "Tracks" && <a onClick={() => { setactiveTab("contractTracks"); apiCall("contractTracks") }} className={activeTab === "contractTracks" ? "btn-success active" : "btn-success"}>CONTRACTS TRACK</a>}
                            {param?.type == "Tracks" && <a onClick={() => { setactiveTab("unlinkedTracks"); apiCall("unlinkedTracks") }} className={activeTab === "unlinkedTracks" ? "btn-success active" : "btn-success"}>UNLINKED TRACKS</a>}
                            {param?.type == "Tracks" && <a onClick={() => { setactiveTab("linkedTracks"); apiCall("linkedTracks") }} className={activeTab === "linkedTracks" ? "btn-success active" : "btn-success"}>TRACKS ALREADY LINKED</a>}
                            {param?.type == "Tracks" && <a onClick={() => { setactiveTab("releaseTracks"); apiCall("releaseTracks") }} className={activeTab === "releaseTracks" ? "btn-success active" : "btn-success"}>RELEASE TRACK</a>}


                            {param?.type == "Songs" && <a onClick={() => { setactiveTab("contractSongs"); apiCall("contractSongs") }} className={activeTab === "contractSongs" ? "btn-success active" : "btn-success"}>CONTRACTS SONG</a>}
                            {param?.type == "Songs" && <a onClick={() => { setactiveTab("unlinkedSongs"); apiCall("unlinkedSongs") }} className={activeTab === "unlinkedSongs" ? "btn-success active" : "btn-success"}>UNLINKED SONG</a>}
                            {param?.type == "Songs" && <a onClick={() => { setactiveTab("linkedSongs"); apiCall("linkedSongs") }} className={activeTab === "linkedSongs" ? "btn-success active" : "btn-success"}>SONG ALREADY LINKED</a>}
                            {param?.type == "Songs" && <a onClick={() => { setactiveTab("releaseSongs"); apiCall("releaseSongs") }} className={activeTab === "releaseSongs" ? "btn-success active" : "btn-success"}>RELEASE SONG</a>}
                            {param?.type == "Songs" && <a onClick={() => { setactiveTab("subAsset"); apiCall("subAsset") }} className={activeTab === "subAsset" ? "btn-success active" : "btn-success"}>SUB ASSET</a>}

                        </ul>
                    </div>

                    <div className="ws-12 ptl pbl">

                        <div className="ws-6">
                            <input type="text" className="ws-10 pull-right height40" placeholder="Title, artist or sequence" value={searchFor} onChange={(e: any) => setSearchFor(e.target.value)} />
                        </div>

                        <div className="ws-4">
                            <button className="icon-btn edit width200 height40" onClick={searchData}>
                                <i className="icon-search"></i> Search {param?.type}
                            </button>

                            <button className="icon-btn info width150 height40" onClick={() => { setSearchFor(""); apiCall(activeTab) }}>
                                <i className="icon-search"></i>View all
                            </button>
                        </div>

                    </div>

                    <div className='ws-12 pm'>
                        <div className='ws-12 pt pbl ml'>
                            <span className='text-bold'>Search result - {ContractAssetLinkedRow} {param?.type?.slice(0, -1)}(s) found</span>
                        </div>

                        {ContractAssetLinkedRow == 0 && <div className="alert alert-info">No records to display </div>}


                        {activeTab != "releaseTracks" && activeTab != "releaseSongs" && <div className='ws-12 allowHscroll allowVscroll'>

                            {(ContractAssetLinkedRow > 0) && <table className='NewTable'>
                                <thead>
                                    <tr>
                                        {
                                            metaDataServices?.ContractAssetheaderMapping?.map((values: any) => {

                                                if (values?.assetType == param?.type && values?.tabName == activeTab) {

                                                    return (
                                                        values.field_display?.map((naming: any) => {
                                                            return (
                                                                <th className=''>{naming}</th>
                                                            )
                                                        })
                                                    )
                                                }
                                            })
                                        }
                                        <th style={{ width: activeTab === "linkedTracks" ? "280px" : "100px" }}>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        ContractAssetLinked?.map((values: any) => {

                                            return (
                                                <tr>
                                                    {
                                                        metaDataServices?.ContractAssetheaderMapping?.map((Mapvalues: any) => {

                                                            if (Mapvalues?.assetType == param?.type && Mapvalues?.tabName == activeTab) {

                                                                return (
                                                                    Mapvalues.field_code?.map((naming: any) => {
                                                                        return (<td className=''>{values?.[naming]}</td>)
                                                                    })
                                                                )
                                                            }
                                                        })
                                                    }
                                                    <td>
                                                        <div className='ws-12 ' style={{}}>
                                                            <div className={activeTab === "linkedSongs" || activeTab === "linkedTracks" ? 'width265 ' + activeTab : 'ws-12 ' + activeTab}>
                                                                {activeTab === "contractTracks" && <button className="icon-btn warning width100 height30" onClick={() => operationType("Un-link", values)}>
                                                                    Un-link
                                                                </button>}

                                                                {(activeTab === "unlinkedTracks" || activeTab == "linkedTracks") && <button className="icon-btn edit width80 height30" onClick={() => operationType("link", values)}>
                                                                    Link
                                                                </button>}

                                                                {activeTab === "linkedTracks" && <button className="icon-btn info width225 height30" onClick={() => { setAssociatedReleaseOpen(true); setAssociatedReleaseSelected(values) }}>
                                                                    Associated Releases
                                                                </button>}


                                                                {activeTab === "contractSongs" && <button className="icon-btn warning width100 height30" onClick={() => operationType("Un-link", values)}>
                                                                    Un-link
                                                                </button>}

                                                                {(activeTab === "unlinkedSongs" || activeTab == "linkedSongs") && <button className="icon-btn edit width80 height30" onClick={() => operationType("link", values)}>
                                                                    Link
                                                                </button>}

                                                                {activeTab === "linkedSongs" && <button className="icon-btn info width170 height30" onClick={() => { setAssociatedReleaseOpen(true); setAssociatedReleaseSelected(values) }}>
                                                                    Associated Releases
                                                                </button>}
                                                            </div>


                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>}

                            <div className="ws-12 pt mtl">
                                {
                                    (() => {
                                        if (ContractAssetLinkedRow > 10) {
                                            return <Pagination onPageChange={paginationContacts} totalRow={ContractAssetLinkedRow} />
                                        }
                                    })()
                                }
                            </div>
                        </div>}

                        {activeTab == "releaseTracks" && <div className='ws-12'>

                            {ContractAssetLinked?.map((values: any) => {

                                return (

                                    <div className='ws-12 box landing mbl'>
                                        <div className='ws-12 box-header pm  box'>
                                            <div className='ws-6'>
                                                <span className='mt ws-12'>Tracks for release {values?.release} - {values?.tracks?.[0]?.totalRows} record(s) found</span>
                                            </div>

                                            <div className="toolbox pull-right m0 ws-6">
                                                <button className="icon-btn edit pull-right" onClick={() => expandOption(values?.release)}>
                                                    <i className={expandOptionShow(values?.release) ? "icon-plus1" : "icon-minus1"} ></i>
                                                </button>
                                                <button className="icon-btn edit pull-right width100" onClick={() => operationType("linkRelease", values)}>Link All </button>
                                            </div>
                                        </div>

                                        {expandOptionShow(values?.release) &&
                                            <div className='ws-12 pm allowHscroll allowVscroll'>

                                                <table className='NewTable'>
                                                    <thead>
                                                        <tr className="forceSingleLine">
                                                            <th>ISRC</th>
                                                            <th>TrackSeq</th>
                                                            <th>Track Title</th>
                                                            <th>Artist </th>
                                                            <th>Contract Ref No.</th>
                                                            <th>VolumeNum</th>
                                                            <th>Sequence</th>
                                                            <th>% Owned</th>
                                                            <th>Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            values?.tracks?.slice((ReleaseTracksPayload.pageNumber - 1) * ReleaseTracksPayload.pageSize, (ReleaseTracksPayload.pageSize * ReleaseTracksPayload.pageNumber))?.map((post: any) => (
                                                                <tr className="forceSingleLine">
                                                                    <td>{post.iSRC}</td>
                                                                    <td>{post.trackSeq}</td>
                                                                    <td>{post.trackName}</td>
                                                                    <td>{post.kontactName}</td>
                                                                    <td>{post.contractRefNum}</td>
                                                                    <td>{post.volumeNum}</td>
                                                                    <td>{post.sequence}</td>
                                                                    <td>{post.percentageOwned}</td>
                                                                    <td>
                                                                        <button className="icon-btn edit width100" onClick={() => operationType("link", post)}>Link </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }

                                                    </tbody>
                                                </table>

                                                <div className="ws-12">
                                                    {
                                                        (() => {
                                                            if (values?.tracks?.[0]?.totalRows > 10) {
                                                                return <Pagination onPageChange={paginationReleaseTracks} totalRow={values?.tracks?.[0]?.totalRows} />
                                                            }
                                                        })()
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </div>
                                )
                            })}

                            <div className="ws-12">
                                {
                                    (() => {
                                        if (ContractAssetLinkedRow > 10) {
                                            return <Pagination onPageChange={paginationContacts} totalRow={ContractAssetLinkedRow} />
                                        }
                                    })()
                                }
                            </div>

                        </div>}

                        {activeTab == "releaseSongs" && <div className='ws-12'>

                            {ContractAssetLinked?.map((values: any) => {

                                return (

                                    <div className='ws-12 box landing mbl'>
                                        <div className='ws-12 box-header pm  box'>
                                            <div className='ws-6'>
                                                <span className='mt ws-12'>Songs for release {values?.release} - {values?.songs?.[0]?.totalRows} record(s) found</span>
                                            </div>

                                            <div className="toolbox pull-right m0 ws-6">
                                                <button className="icon-btn edit pull-right" onClick={() => expandOption(values?.release)}>
                                                    <i className={expandOptionShow(values?.release) ? "icon-plus1" : "icon-minus1"} ></i>
                                                </button>
                                                <button className="icon-btn edit pull-right width100" onClick={() => operationType("linkRelease", values)}>Link All </button>
                                            </div>
                                        </div>

                                        {expandOptionShow(values?.release) &&
                                            <div className='ws-12 pm allowHscroll allowVscroll'>

                                                <table className='NewTable'>
                                                    <thead>
                                                        <tr className="forceSingleLine">
                                                            <th>Song Ref</th>
                                                            <th>Song Title</th>
                                                            <th>Song Main Composer</th>
                                                            <th>Song Main Publisher</th>
                                                            <th>ISWC</th>
                                                            <th>% Owned</th>
                                                            <th>Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            values?.songs?.slice((ReleaseSongsPayload.pageNumber - 1) * ReleaseSongsPayload.pageSize, (ReleaseSongsPayload.pageSize * ReleaseSongsPayload.pageNumber))?.map((post: any) => (
                                                                <tr className="forceSingleLine">
                                                                    <td>{post.songRef}</td>
                                                                    <td>{post.songName}</td>
                                                                    <td>{post.songMainComposer}</td>
                                                                    <td>{post.songMainPublisher}</td>
                                                                    <td>{post.contractRefNum}</td>
                                                                    <td>{post.percentageOwned}</td>
                                                                    <td>
                                                                        <button className="icon-btn edit width70" onClick={() => operationType("link", post)}>Link </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }

                                                    </tbody>
                                                </table>

                                                <div className="ws-12">
                                                    {
                                                        (() => {
                                                            if (values?.songs?.[0]?.totalRows > 10) {
                                                                return <Pagination onPageChange={paginationReleaseSong} totalRow={values?.songs?.[0]?.totalRows} />
                                                            }
                                                        })()
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </div>
                                )
                            })}

                            <div className="ws-12">
                                {
                                    (() => {
                                        if (ContractAssetLinkedRow > 10) {
                                            return <Pagination onPageChange={paginationContacts} totalRow={ContractAssetLinkedRow} />
                                        }
                                    })()
                                }
                            </div>

                        </div>}

                    </div>
                </div>

                <div className="box-footer">
                    <button className="icon-btn delete width80 height35 pull-right" onClick={closeDrawer}><i className="fa fa-close"></i> Close
                    </button>
                </div>

                {
                    (() => {
                        if (AssociatedReleaseOpen) {
                            return <AssociatedTrackRelease AssociatedReleaseOpen={AssociatedReleaseOpen}
                                onChangAssociatedRelease={onChangAssociatedRelease} AssociatedReleaseSelected={AssociatedReleaseSelected}
                                contract={param?.contractDetails?.contractRefNum} />
                        }
                    })()
                }
            </div >

        </Drawer >
    </>)

}